<script>
import SectionItem from "./index/SectionItem";

export default Vue.extend({
  components: {
    SectionItem
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/help/Index.vue